// extracted by mini-css-extract-plugin
module.exports = {"container":"Common_container__5UcyX","pageContents":"Common_pageContents__3iywe"};